<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-select v-model="ownerId" :options="owners" placeholder="placeholder.pleaseSelectOwner" @change="onOwnerChange"/>
        <vxe-select v-model="inventoryState" :options="inventoryStates" placeholder="placeholder.inventoryStatus"/>
      </template>
      <template #extra>
        <vxe-button content="button.taken" icon="vxe-icon-search" status="primary" @click="fetch"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.save" icon="vxe-icon-save" status="primary" @click="save"/>
      </template>
      <vxe-table ref="table" :data="data" :edit-config="{}" :loading="loading" :min-height="780" keep-source>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName"/>
        <vxe-column field="pack.specification" title="business.label.specification"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="lot.no" title="business.label.lotNo"/>
        <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer"/>
        <vxe-column field="location.no" title="business.label.location"/>
        <vxe-column field="storageRoom.name" title="business.label.storageRoom"/>
        <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="90"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:inventoryStates}" field="inventoryState" title="business.label.inventoryState"/>
        <vxe-column :edit-render="{name:'VxeInput',props:{editable:false},events:{click:({row})=>onReasonSelect(row)}}" field="reason.name" title="title.reason"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <InventoryModal ref="inventoryModal" selectType="checkbox" @change="changeInventory"/>
    <field-modal ref="reasonModal" :show-name="true" :show-no="false" :show-value="false" :title="$t('title.reason')" no="REASON" @change="onReasonChange"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { OPERATOR, WAREHOUSE } from '@/store/mutation-types'
import { findAll, post } from '@/api/Api'
import Api from '@/api'
import FieldModal from '@/views/modal/FieldModal.vue'
import InventoryModal from '@/views/modal/InventoryModal.vue'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { getEnums, getOptions } from '@/utils/util'

export default {
  name: 'InventoryStatusChange',
  components: { FieldModal, InventoryModal },
  props: {
    queryParam: { type: Object, default: null }
  },
  data() {
    return {
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      data: [],
      ownerId: undefined,
      inventoryState: undefined,
      owners: [],
      inventoryStates: []
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return getEnums('InventoryState')
    }).then(result => {
      this.inventoryStates = result
    })
  },
  methods: {
    onOwnerChange() {
      this.data = []
    },
    changeInventory(values) {
      this.data = values.map(item => {
        const detail = JSON.parse(JSON.stringify(item))
        detail.quantity = item.inventory.availableQuantity
        detail.inventoryState = item.inventory.inventoryState
        detail.reason = new Dictionary()
        return detail
      })
    },
    onReasonSelect(row) {
      this.$refs.reasonModal.open({}, row)
    },
    onReasonChange(values, row) {
      row.reason = new Dictionary(values[0])
    },
    fetch() {
      if (!this.ownerId) {
        return this.$message.warning('请先选择货主')
      }
      this.$refs.inventoryModal.open({ 'owner.id': this.ownerId, available: true, physical: true })
    },
    reset() {
      this.data = []
      this.ownerId = undefined
      this.inventoryState = undefined
    },
    save() {
      if (this.inventoryState === undefined) {
        return this.$message.warning('请选择库存状态')
      }
      this.loading = true
      const order = {
        warehouse: { id: this.warehouse.id },
        orderType: { id: this.queryParam.value.business.orderType.id },
        owner: { id: this.ownerId },
        dataSource: 4,
        inventoryState: this.inventoryState,
        inspector: this.operator.name,
        details: this.data.map(item => {
          return {
            sku: { id: item.sku.id },
            quantity: item.quantity,
            location: { id: item.location.id },
            container: item.container === null ? null : { id: item.container.id },
            inventoryState: item.inventoryState,
            reason: item.reason.skipNulls()
          }
        })
      }
      post(Api.conversionConverterSubmit, {}, order).then(res => {
        if (res.success) {
          this.data = []
          this.$message.success(this.$t('message.saveSuccess'))
        }
      }).finally(() => this.loading = false)
    },
    remove(row) {
      this.data.splice(this.data.indexOf(row), 1)
    }
  }
}
</script>